import { LegacyExamQuestionMarkOutcome } from './enums';

const listAttributes = [
  'questionId',
  'marksBreakdown',
  'markerId',
  'markerDetails',
  'markedDatetime',
  'creationDatetime',
  'outcome',
  'mark',
  'maxMark',
  'examLabel',
  'examType',
  'questionLabel',
  'inaccuracyMarks',
  'sillyMarks',
  'response',
  'criteria',
  'markerComment',
  'mcqAutomark',
  'markingMode',
] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'questionLabel',
  'mark',
  'maxMark',
  'outcome',
  'examLabel',
  'markedDatetime',
  'markerId',
  'markerDetails',
  'type',
  'mcqOpts',
  'missedMarks',
  'sillyMarks',
  'inaccuracyMarks',
  'marksBreakdown',
  'examType',
  'examSubject',
  'examId',
  'question',
  'studentDetails',
  'status',
  'criteria',
  'markerComment',
  'markingMode',
] as const;

export const LegacyExamQuestionAttemptAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

// Maximum number of papers that can be in progress of marking at a time per marker
export const MAX_SIMULTANEOUS_LEGACY_MARKING = 30;

export const ERROR_TYPES = [
  {
    key: LegacyExamQuestionMarkOutcome.Missed,
    value: LegacyExamQuestionMarkOutcome.Missed,
    label: 'Missed',
  },
  {
    key: LegacyExamQuestionMarkOutcome.SillyMistake,
    value: LegacyExamQuestionMarkOutcome.SillyMistake,
    label: 'Silly Mistake',
  },
  {
    key: LegacyExamQuestionMarkOutcome.Inaccuracy,
    value: LegacyExamQuestionMarkOutcome.Inaccuracy,
    label: 'Incorrect',
  },
];
